/**
 * @author      matthew@zumper.com (Matthew Talamini)
 * @copyright   Copyright (c) 2022, Zumper
 * @description oforEach utility function
 */

/* export type TwoCallback<D extends object> = (
  ...args: { [K in keyof D]: [value: D[K], key: K] }[keyof D]
) => void
export type ThreeCallback<D extends object> = (
  ...args: { [K in keyof D]: [value: D[K], key: K, obj: D] }[keyof D]
) => void
export type Callback<D extends object> = TwoCallback<D> | ThreeCallback<D>
export interface OForEach {
  <D extends object>(obj: D | null | undefined, callback: ThreeCallback<D>): void
  <D extends object>(obj: D | null | undefined, callback: TwoCallback<D>): void
  <D extends object>(obj: D | null | undefined, callback: Callback<D>): void
} */

export type Callback<D extends object> = <K extends keyof D>(value: D[K], key: K, obj: D) => void

/**
 * forEach over Object.keys, callback(value, key, obj)
 *
 * @param obj
 * @param callback
 */
export const oforEach = <D extends object>(obj: D | null | undefined, callback: Callback<D>) => {
  if (obj) {
    for (const [k, v] of Object.entries(obj)) {
      callback(v, k as any, obj as any)
    }
  }
}
